import { alpha } from '@mui/material/styles'
import type { SxProps, Theme } from '@mui/material/styles'

/** Thêm / Sửa / Xem — cùng kích thước vùng header, chỉ khác màu nền */
export type ModalHeaderIntent = 'create' | 'edit' | 'view' | 'default'

/** Padding + chiều cao tối thiểu giống nhau cho mọi intent */
export const modalHeaderTitlePaddingSx: SxProps<Theme> = {
  py: { xs: 0.85, sm: 1 },
  px: { xs: 1.5, sm: 1.75 },
  pr: { xs: 1, sm: 1.25 },
  minHeight: 48,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

/**
 * Nền header theo theme accent (đổi màu chủ đề → header modal đổi theo).
 * - create: tint primary / `muahang.primarySurface`
 * - edit: tint warning (vẫn lấy từ palette theme)
 * - view: tint info (thường = primary.light theo accent)
 * - default: grey paper
 */
export function modalHeaderTitleBackgroundSx(intent: ModalHeaderIntent = 'default'): SxProps<Theme> {
  return (theme) => {
    const dark = theme.palette.mode === 'dark'
    const primary = theme.palette.primary.main
    const warning = theme.palette.warning.main
    const info = theme.palette.info.main
    const primarySurface = theme.palette.muahang?.primarySurface

    if (intent === 'create') {
      return {
        bgcolor: dark ? alpha(primary, 0.24) : primarySurface ?? alpha(primary, 0.1),
      }
    }
    if (intent === 'edit') {
      return {
        bgcolor: dark ? alpha(warning, 0.22) : alpha(warning, 0.14),
      }
    }
    if (intent === 'view') {
      return {
        bgcolor: dark ? alpha(info, 0.22) : alpha(info, 0.12),
      }
    }
    return {
      bgcolor: dark ? alpha(theme.palette.grey[900], 0.55) : theme.palette.grey[50],
    }
  }
}
